import DashboardPage from '../components/dashboard/dashboardPage';
import NewClaimPage from '../components/disputeMgmt/newClaim/newClaimPage';
import DisputesPage from '../components/disputeMgmt/disputes/disputesPage';
import BulkDisputesPage from '../components/disputeMgmt/bulkDisputes/bulkDisputesPage';
import ScriptsPage from '../components/admin/scripts/scriptsPage';
import ReasonCodesPage from '../components/admin/reasonCodes/reasonCodesPage';
import DisputeRegionsPage from '../components/admin/disputeRegions/disputeRegionsPage';
import TransactionGroupsPage from '../components/admin/transactionGroups/transactionGroupsPage';
import TransactionTypesPage from '../components/admin/transactionTypes/transactionTypesPage';
import TransactionTimelinesPage from '../components/admin/transactionTimelines/transactionTimelinesPage';
import DisputeTimelinesPage from '../components/admin/disputeTimelines/disputeTimelinesPage';
import MerchantDisputantsPage from '../components/admin/merchantDisputants/merchantDisputantsPage';
import SettlementRequestsPage from '../components/admin/settlementRequests/settlementRequestsPage';

import Constants from './constants';

export default {
    DASHBOARD_ROUTE: {
        key : "dashboard",
        name : "Dashboard",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/dashboard`,
        pageComponent: DashboardPage
    },
    NEW_CLAIM_ROUTE: {
        key : "newclaim",
        name : "New Claim",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/newclaim`,
        pageComponent: NewClaimPage
    },
    DISPUTES_ROUTE: {
        key: "disputes",
        name : "Disputes",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/disputes`,
        pageComponent: DisputesPage
    },
    BULK_DISPUTES_ROUTE: {
        key: "bulk_disputes",
        name : "Dispute Batches",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/disputemgmt/bulkDisputes`,
        pageComponent: BulkDisputesPage
    },
    
    DISPUTE_REGIONS_ROUTE: {
        key: "disputeRegions",
        name : "Dispute Regions",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/disputeRegions`,
        pageComponent: DisputeRegionsPage
    },
    DISPUTE_TIMELINE_ROUTE: {
        key: "disputeTimelines",
        name : "Dispute Timelines",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/disputeTimelines`,
        pageComponent: DisputeTimelinesPage
    },
     
    MERCHANT_DISPUTANT_ROUTE: {
        key: "merchantDisputant",
        name : "Merchant Disputants",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/merchantDisputant`,
        pageComponent: MerchantDisputantsPage
    },
    REASON_CODES_ROUTE: {
        key: "reasonCodesRoute",
        name : "Reason Codes",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/reasonCodes`,
        pageComponent: ReasonCodesPage
    },

    SCRIPTS_ROUTE: {
        key: "scripts",
        name : "Scripts",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/scripts`,
        pageComponent: ScriptsPage
    },
    SETTLEMENT_REQUEST_ROUTE: {
        key: "settlementRequests",
        name : "Settlement Requests",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/settlementRequests`,
        pageComponent: SettlementRequestsPage
    },
    
    TRANSACTION_GROUPS_ROUTE: {
        key: "transactionGroups",
        name : "Transaction Groups",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/transactionGroups`,
        pageComponent: TransactionGroupsPage
    },
    TRANSACTION_TYPES_ROUTE: {
        key: "transactionTypes",
        name : "Transaction Types",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/transactionTypes`,
        pageComponent: TransactionTypesPage
    },
    TRANSACTION_TIMELINE_ROUTE: {
        key: "transactionTimelines",
        name : "Transaction Timelines",
        path: `${Constants.ROUTES_BASE_CONTEXT_PATH}/admin/transactionTimelines`,
        pageComponent: TransactionTimelinesPage
    },

  
}


// WEBPACK FOOTER //
// ./src/configurations/routesConfig.js